import React, { useState, useEffect } from "react";
import boardImageone from "../../assets/img/blog/generational-trauma.jpg";
import MarketingPageLayout from "./MarketingPageLayout";
import styles from "./UserStories.module.css";
import API from "../../api/api";
import { auth } from "../../firebase.config";
import { useNavigate } from "react-router-dom";

interface Comment {
  id: string;
  authorId: string;
  authorName: string;
  content: string;
  createdAt: string;
}

interface Blog {
  imageUrl: string;
  id: string;
  authorId: string;
  authorName: string;
  readTime: number;
  title: string;
  category: string;
  content: string;
  tags: string[];
  featuredImage: string | null;
  status: string;
  dislikes: number;
  likes: number;
  views: number;
  comments: Comment[];
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
}

const LikeDislikeButtons: React.FC<{
  blogId: string;
  authorId: string
  likes: number;
  dislikes: number;
  onLike: (id: string) => void;
  onDislike: (id: string) => void;
  size?: "sm" | "md" | "lg";
}> = ({ blogId, authorId, likes, dislikes, onLike, onDislike, size = "md" }) => {
  const btnClass = size === "sm" ? "btn-sm" : "";
  const navigate = useNavigate();
  const user = auth.currentUser;

  const [, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    setLoading(true);
    setError(null);

    try {
      const token = await user?.getIdToken();
      await API.delete(`/blogs/${blogId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoading(false);
      navigate("/user-stories");
    } catch (err: any) {
      setLoading(false);
      setError(
        err.response?.data?.message || "Failed to delete blog. Please try again."
      );
    }
  };

  return (
    <div className="d-flex align-items-center gap-3">
      {/* <button
        className={`btn ${btnClass} ${
          size === "sm" ? "border-dark custom-like-btn" : "custom-like-btn"
        }`}
        onClick={() => onLike(blogId)}
      >
        <i className="fa fa-thumbs-up me-1"></i>
      </button>
      <div>
        <p
          className={`fw-bold text-primary ${size === "sm" ? "fs-5" : "fs-3"}`}
        >
          {likes}
        </p>
      </div>
      <button
        className={`btn ${btnClass} ${
          size === "sm" ? "border-dark custom-like-btn" : "custom-dislike-btn"
        }`}
        onClick={() => onDislike(blogId)}
      >
        <i className="fa fa-thumbs-down me-1"></i>
      </button> */}
     {user?.uid === authorId && <button
        className={`btn ${btnClass} ${
         size === "sm" ? "border-dark custom-like-btn" : "custom-like-btn"
        }`}
        onClick={() => navigate(`/edit-blog/${blogId}`)}
      >
      <i className="fa fa-edit me-1"></i>

      </button>
}

{user?.uid === authorId &&
      <button
        className={`btn ${btnClass} ${
          size === "sm" ? "border-dark custom-like-btn" : "custom-dislike-btn"
        }`}

        onClick={handleDelete}
        // onClick={() => Handle delete logic from here (blogId)}
      >
       <i className="fa fa-trash me-1"></i>
      </button>
}
{error && <p className="text-danger mb-0 small">{error}</p>}
    </div>
  );
};

const CommentList: React.FC<{ 
  comments: Comment[];
  onDeleteComment?: (commentId: string, blogId: string) => void;
  blogId: string;
}> = ({ comments, onDeleteComment, blogId }) => {
  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return date.toLocaleDateString(undefined, options);
    } catch (error) {
      return "Invalid Date";
    }
  };

  const getTimeAgo = (dateString: string) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "";
      }
      const now = new Date();
      const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
      
      if (diffInSeconds < 60) return "just now";
      if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
      if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
      if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)}d ago`;
      return formatDate(dateString);
    } catch (error) {
      return "";
    }
  };

  const user = auth.currentUser;

  return (
    <div className="comments-section">
      <div className="d-flex align-items-center mb-4">
        <h4 className="mb-0 me-3">
          <i className="fa fa-comments text-primary me-2"></i>
          Comments ({comments.length})
        </h4>
        <div className="flex-grow-1">
          <hr className="my-0" />
        </div>
      </div>
      
      {comments.length === 0 ? (
        <div className="text-center text-muted py-5">
          <div className="mb-3">
            <i className="fa fa-comment-o fa-3x text-muted opacity-50"></i>
          </div>
          <h5 className="text-muted">No comments yet</h5>
          <p className="text-muted">Be the first to share your thoughts on this story!</p>
        </div>
      ) : (
        <div className="comments-list">
          {comments.map((comment, index) => (
            <div key={comment.id} className={`border-bottom pb-3 mb-3 ${index === comments.length - 1 ? 'border-0 pb-0 mb-0' : ''}`}>
              <div className="d-flex">
                <div className="me-3">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '40px', height: '40px', fontSize: '14px', fontWeight: 'bold'}}>
                    {comment.authorName.charAt(0).toUpperCase()}
                  </div>
                </div>
                <div className="flex-grow-1">
                  <div className="p-3 rounded" style={{borderLeft: '3px solid #007bff'}}>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="d-flex align-items-center">
                        <h6 className="mb-0 me-2 fw-semibold text-dark">{comment.authorName}</h6>
                        {comment.authorId === user?.uid && (
                          <span className="badge bg-primary bg-opacity-10 text-primary small px-2 py-1">
                            <i className="fa fa-user me-1"></i>You
                          </span>
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        <small className="text-muted me-2" title={formatDate(comment.createdAt)}>
                          {getTimeAgo(comment.createdAt)}
                        </small>
                        {comment.authorId === user?.uid && onDeleteComment && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => {
                              if (window.confirm("Are you sure you want to delete this comment?")) {
                                onDeleteComment(comment.id, blogId);
                              }
                            }}
                            title="Delete comment"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        )}
                      </div>
                    </div>
                    <div>
                      <p className="mb-0 text-secondary" style={{lineHeight: '1.5'}}>{comment.content}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
    </div>
  );
};

const CommentForm: React.FC<{
  onSubmit: (author: string, text: string) => void;
}> = ({ onSubmit }) => {
  const [author, setAuthor] = useState("");
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    
    if (!comment.trim()) {
      setError("Please enter a comment");
      return;
    }

    if (comment.trim().length < 3) {
      setError("Comment must be at least 3 characters long");
      return;
    }

    setIsSubmitting(true);
    
    try {
      await onSubmit(author || "Anonymous User", comment);
      setComment("");
      setAuthor("");
    } catch (err) {
      setError("Failed to submit comment. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`${styles.commentFormShell} mt-5 p-4 rounded-3`} style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', border: '1px solid #dee2e6'}}>
      <div className="mb-4">
        <h5 className="mb-2">
          <i className="fa fa-edit text-primary me-2"></i>
          Share Your Thoughts
        </h5>
        <p className="text-muted mb-0">Join the conversation and share your perspective on this story.</p>
      </div>
      
      <div className="bg-white p-4 rounded-3 shadow-sm">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="comment-textarea" className="form-label fw-semibold">
              Your Comment
            </label>
            <textarea
              id="comment-textarea"
              className="form-control"
              rows={4}
              placeholder="What are your thoughts on this story? Share your insights, experiences, or questions..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              required
              disabled={isSubmitting}
              maxLength={500}
              style={{border: '2px solid #e9ecef', borderRadius: '0.5rem', fontSize: '14px', lineHeight: '1.5'}}
            ></textarea>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <div className="form-text text-muted">
                <i className="fa fa-info-circle me-1"></i>
                Minimum 3 characters required
              </div>
              <div className={`small fw-medium ${comment.length > 450 ? 'text-warning' : comment.length > 480 ? 'text-danger' : 'text-muted'}`}>
                {comment.length}/500 characters
              </div>
            </div>
          </div>
          
          {error && (
            <div className="alert alert-danger mb-3" role="alert">
              <i className="fa fa-exclamation-triangle me-2"></i>
              {error}
            </div>
          )}
          
          <div className="d-flex justify-content-end">
            <button
              type="submit" 
              className={`btn btn-primary btn-lg px-4 fw-semibold ${styles.primaryBtn}`}
              disabled={isSubmitting || !comment.trim() || comment.trim().length < 3}
              style={{borderRadius: '0.5rem'}}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Posting Comment...
                </>
              ) : (
                <>
                  <i className="fa fa-paper-plane me-2"></i>
                  Post Comment
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const BlogCard: React.FC<{
  blog: Blog;
  onSelect: (id: string) => void;
  onLike: (id: string) => void;
  onDislike: (id: string) => void;
  onShare: (blog: Blog) => void;
}> = ({ blog, onSelect, onLike, onDislike, onShare }) => {
  const formatDate = (timestamp: { _seconds: number; _nanoseconds: number }) => {
    const date = new Date(timestamp._seconds * 1000);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString(undefined, options);
  };
  return (
    <div className={`card h-100 rounded overflow-hidden shadow-sm hover-shadow transition-300 ${styles.storyCard}`}>
      <div className="position-relative overflow-hidden">
        <img
          className={`card-img-top ${styles.storyImage}`}
          src={blog.featuredImage || boardImageone}
          alt={blog.title}
          style={{
            width: "100%",
            height: "220px",
            objectFit: "cover",
          }}
          onClick={() => onSelect(blog.id)}
        />
        {/* <div className="position-absolute start-0 top-0 m-3">
          <span className="badge bg-primary rounded-pill px-3 py-2">
            <i className="fa fa-eye me-1"></i> {blog.views}
          </span>
        </div> */}
        <div className={`bg-white rounded-top text-primary position-absolute start-0 bottom-0 mx-4 pt-1 px-3 shadow ${styles.storyCategory}`}>
          {blog.category}
        </div>
      </div>
      <div className="p-4 flex-grow-1 d-flex flex-column">
        <div className="d-flex justify-content-between mb-2">
          <small className="text-muted">
            <i className="fa fa-calendar me-1"></i>
            {formatDate(blog.createdAt)}
          </small>
          <small className="text-muted">
            <i className="fa fa-user me-1"></i>
            {blog.authorName}
          </small>
        </div>
        <h5 className="card-title mb-3">
          <button
            type="button"
            onClick={() => onSelect(blog.id)}
            className={`text-decoration-none text-primary border-0 bg-transparent p-0 text-start ${styles.storyTitleLink}`}
          >
            {blog.title}
          </button>
        </h5>
        <p className="card-text mb-3 text-truncate-2">
          {blog.content}
        </p>
        <div className="mt-auto">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <i className="fa fa-comment me-1 text-muted"></i>
              <span className="text-muted me-3">
                {blog.comments.length}
              </span>
              {/* <StarRating rating={blog.likes / (blog.views || 1)} /> */}
            </div>
            <button
              className={`btn btn-sm btn-outline-primary ${styles.readMoreBtn}`}
              onClick={() => onSelect(blog.id)} 
            >
              Read More
            </button>
          </div>
        </div>
      </div>
      <div className="card-footer bg-white border-0 p-4 pt-0">
        <div className="d-flex justify-content-between">
          {/* <LikeDislikeButtons
            blogId={blog.id}
            likes={blog.likes}
            dislikes={0} // Assuming dislikes aren't in the backend response
            onLike={onLike}
            onDislike={onDislike}
            size="sm"
          /> */}
          {/* <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => onShare(blog)}
          >
            <i className="fa fa-share-alt"></i>
          </button> */}
        </div>
      </div>
    </div>
  );
};

const BlogDetail: React.FC<{
  blog: Blog;
  onBack: () => void;
  onLike: (id: string) => void;
  onDislike: (id: string) => void;
  onShare: (blog: Blog) => void;
  onCommentSubmit: (blogId: string, author: string, text: string) => void;
  onDeleteComment: (commentId: string, blogId: string) => void;
}> = ({ blog, onBack, onLike, onDislike, onShare, onCommentSubmit, onDeleteComment }) => {
  const formatDate = (timestamp: { _seconds: number; _nanoseconds: number }) => {
    const date = new Date(timestamp._seconds * 1000);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString(undefined, options);
  };

  return (
    <div className="row">
      <div className="col-12 mb-4">
        <button className={`btn btn-outline-primary ${styles.backBtn}`} onClick={onBack}>
          <i className="fa fa-arrow-left me-2"></i>Back to all stories
        </button>
      </div>

      <div className="col-12">
        <div className={`card shadow-sm border-0 rounded-3 overflow-hidden ${styles.detailCard}`}>
          <div className="position-relative">
            <img
              src={blog.featuredImage || boardImageone}
              className="card-img-top"
              alt={blog.title}
              style={{
                maxHeight: "600px",
                objectFit: "cover",
                objectPosition: "top bottom",
              }}
            />
            <div className="position-absolute top-0 start-0 m-4">
              <span className="badge bg-primary text-white px-3 py-2 rounded-pill">
                <i className="fa fa-eye me-1"></i>
                {blog.views} views
              </span>
            </div>
          </div>

          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="text-muted">
                <i className="fa fa-calendar me-1"></i>
                {formatDate(blog.createdAt)}
              </span>
              <span className="text-muted">
                <i className="fa fa-user me-1"></i>By {blog.authorName}
              </span>
            </div>

            <h2 className="card-title mb-4">{blog.title}</h2>

            <div className="card-text mb-4">
              <p>{blog.content}</p>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center">
                <div className="me-4">
                  <LikeDislikeButtons
                    blogId={blog.id}
                    authorId={blog.authorId}
                    likes={blog.likes}
                    dislikes={0}
                    onLike={onLike}
                    onDislike={onDislike}
                  />
                  
                </div>
                {/* <div>
                  <StarRating rating={blog.likes / (blog.views || 1)} />
                </div> */}
              </div>

              <button
                className="btn btn-outline-primary"
                onClick={() => onShare(blog)}
              >
                <i className="fa fa-share-alt me-1"></i>Share
              </button>
            </div>

            <hr />

            <div className="comments-section mt-4">
              <CommentList 
                comments={blog.comments} 
                onDeleteComment={onDeleteComment}
                blogId={blog.id}
              />
              <CommentForm
                onSubmit={(author, text) =>
                  onCommentSubmit(blog.id, author, text)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserStories: React.FC = () => {
  const [selectedBlog, setSelectedBlog] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSort] = useState("newest");
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const navigate = useNavigate();

  const fetchBlogs = async (showLoading = true) => {
    try {
      if (showLoading) setIsLoading(true);
      setError(null);

      const response = await API.get('/blogs');

      setBlogs(response.data.blogs || []);
    } catch (err: any) {
      console.error('Error fetching blogs:', err);
      setError(err.response?.data?.message || err.message || 'Failed to fetch blogs. Please try again.');
    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleLike = (blogId: string) => {
    setBlogs((prevBlogs) =>
      prevBlogs.map((blog) => {
        if (blog.id === blogId) {
          return {
            ...blog,
            likes: blog.likes + 1,
          };
        }
        return blog;
      })
    );
  };

  const handleDislike = (blogId: string) => {
    setBlogs((prevBlogs) =>
      prevBlogs.map((blog) => {
        if (blog.id === blogId) {
          return {
            ...blog,
            dislikes: (blog.dislikes || 0) + 1,
          };
        }
        return blog;
      })
    );
  };

  const handleShare = (blog: Blog) => {
    alert(
      `Share blog: ${blog.title} (URL would be copied or sharing dialog would appear)`
    );
  };

  const handleCommentSubmit = async (
    blogId: string,
    author: string,
    text: string
  ) => {
    const tempId = `temp-${Date.now()}`;
    
    try {
      const user = auth.currentUser;
      if (!user) {
        alert("Please log in to add comments");
        return;
      }

      const token = await user.getIdToken();
      
      const commentData = {
        blog_id: blogId,
        authorName: author || user.displayName || "Anonymous User",
        content: text.trim(),
        authorId: user.uid
      };

      // Optimistically add the comment to the UI immediately
      const optimisticComment: Comment = {
        id: tempId, // Temporary ID
        authorId: user.uid,
        authorName: author || user.displayName || "Anonymous User",
        content: text.trim(),
        createdAt: new Date().toISOString()
      };

      // Update the local state immediately
      setBlogs((prevBlogs) =>
        prevBlogs.map((blog) => {
          if (blog.id === blogId) {
            return {
              ...blog,
              comments: [...blog.comments, optimisticComment],
            };
          }
          return blog;
        })
      );

      const response = await API.post(`/blogs/${blogId}/comment`, commentData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        // Replace the optimistic comment with the real one from the server
        const realComment = response.data.comment;
        setBlogs((prevBlogs) =>
          prevBlogs.map((blog) => {
            if (blog.id === blogId) {
              return {
                ...blog,
                comments: blog.comments.map((comment) =>
                  comment.id === tempId ? realComment : comment
                ),
              };
            }
            return blog;
          })
        );
        
        // Show success message
        alert("Comment added successfully!");
      }
    } catch (err: any) {
      console.error('Error adding comment:', err);
      
      // Remove the optimistic comment on error
      setBlogs((prevBlogs) =>
        prevBlogs.map((blog) => {
          if (blog.id === blogId) {
            return {
              ...blog,
              comments: blog.comments.filter((comment) => comment.id !== tempId),
            };
          }
          return blog;
        })
      );
      
      alert(err.response?.data?.message || "Failed to add comment. Please try again.");
    }
  };

  const handleDeleteComment = async (commentId: string, blogId: string) => {
    try {
      const user = auth.currentUser;
      if (!user) {
        alert("Please log in to delete comments");
        return;
      }

      const token = await user.getIdToken();
      
      // Optimistically remove the comment from the UI immediately
      setBlogs((prevBlogs) =>
        prevBlogs.map((blog) => {
          return {
            ...blog,
            comments: blog.comments.filter((comment) => comment.id !== commentId),
          };
        })
      );
      
      const response = await API.delete(`/blogs/${blogId}/comment/${commentId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        // Show success message
        alert("Comment deleted successfully!");
      }
    } catch (err: any) {
      console.error('Error deleting comment:', err);
      
      // If deletion failed, refresh to get the correct state
      await fetchBlogs(false);
      
      alert(err.response?.data?.message || "Failed to delete comment. Please try again.");
    }
  };

  const filteredBlogs = blogs.filter(
    (blog) =>
      blog.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.content?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.authorName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedBlogs = [...filteredBlogs].sort((a, b) => {
    if (sortBy === "newest") {
      return b.createdAt._seconds - a.createdAt._seconds;
    } else if (sortBy === "oldest") {
      return a.createdAt._seconds - b.createdAt._seconds;
    } else if (sortBy === "mostViewed") {
      return b.views - a.views;
    } else if (sortBy === "topRated") {
      return b.likes - a.likes;
    }
    return 0;
  });

  const blogDetail = selectedBlog
    ? blogs.find((blog) => blog.id === selectedBlog)
    : null;

  const handleRefresh = () => {
    setIsRefreshing(true);
    fetchBlogs(false);
  };

  const LoadingState = () => (
    <div className="text-center py-5">
      <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-muted">Loading stories...</p>
    </div>
  );

  const ErrorState = () => (
    <div className="alert alert-danger m-4" role="alert">
      <div className="d-flex align-items-center">
        <i className="fas fa-exclamation-circle me-2"></i>
        <div>
          <h5 className="alert-heading mb-1">Error Loading Stories</h5>
          <p className="mb-0">{error}</p>
        </div>
      </div>
      <hr />
      <button 
        className="btn btn-outline-danger btn-sm" 
        onClick={handleRefresh}
        disabled={isRefreshing}
      >
        {isRefreshing ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Retrying...
          </>
        ) : (
          <>
            <i className="fas fa-sync-alt me-2"></i>
            Try Again
          </>
        )}
      </button>
    </div>
  );

  return (
    <MarketingPageLayout>
      <div className={`container-xxl py-5 ${styles.page}`}>
        <div className="container">
        <div className={`row g-0 gx-5 align-items-end mb-4 ${styles.toolbarRow}`}>
  <div className="col-lg-6">
    <div
      className="text-start mx-auto mb-4 wow slideInLeft"
      data-wow-delay="0.1s"
    >
      <h1 className="mb-3">User Stories</h1>
      <p className="text-muted">
        Discover family history research insights, tips, and
        experiences from our community.
      </p>
    </div>
  </div>
  <div
    className="col-lg-6 text-lg-end wow slideInRight"
    data-wow-delay="0.1s"
  >
    <div className="d-flex justify-content-lg-end align-items-center">
      <button 
        className={`btn btn-primary me-3 d-flex align-items-center ${styles.primaryBtn}`}
        onClick={() => navigate('/newblog')} // Adjust the route as needed
      >
        <i className="fa fa-plus me-2"></i>
        Add New Story
      </button>
      
      <div className={`d-flex ${styles.filtersWrap}`}>
        <div className={`input-group me-2 ${styles.searchGroup}`} style={{ maxWidth: "300px" }}>
          <input
            type="text"
            className={`form-control border-primary ${styles.searchInput}`}
            placeholder="Search stories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            disabled={isLoading}
          />
          <button className={`btn btn-primary ${styles.searchBtn}`} type="button" disabled={isLoading}>
            <i className="fa fa-search"></i>
          </button>
        </div>
        <select
          className={`form-select ${styles.sortSelect}`}
          style={{ width: "auto" }}
          value={sortBy}
          onChange={(e) => setSort(e.target.value)}
          disabled={isLoading}
        >
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="mostViewed">Most Viewed</option>
          <option value="topRated">Top Rated</option>
        </select>
      </div>
    </div>
  </div>
</div>

          {isLoading ? (
            <LoadingState />
          ) : error ? (
            <ErrorState />
          ) : blogDetail ? (
            <BlogDetail
              blog={blogDetail}
              onBack={() => setSelectedBlog(null)}
              onLike={handleLike}
              onDislike={handleDislike}
              onShare={handleShare}
              onCommentSubmit={handleCommentSubmit}
              onDeleteComment={handleDeleteComment}
            />
          ) : (
            <div className="row g-4">
              {sortedBlogs.length > 0 ? (
                sortedBlogs.map((blog) => (
                  <div
                    key={blog.id}
                    className="col-lg-4 col-md-6 wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    <BlogCard
                      blog={blog}
                      onSelect={setSelectedBlog}
                      onLike={handleLike}
                      onDislike={handleDislike}
                      onShare={handleShare}
                    />
                  </div>
                ))
              ) : (
                <div
                  className="col-12 text-center wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  <div className="alert alert-info" role="alert">
                    <i className="fa fa-info-circle me-2"></i> No stories found
                    matching your search criteria.
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </MarketingPageLayout>
  );
};

export default UserStories;